const ENV_CONFIG = {
  local: {
    REACT_APP_APP_HOST: 'localhost:3000',
    REACT_APP_WWW_HOST: 'localhost:3001',
    REACT_APP_API_HOST: 'dev.api.culinistas.fuzzhq.com',
    REACT_APP_SCHEMA: 'http'
  },
  dev: {
    REACT_APP_APP_HOST: 'dev.app.culinistas.fuzzhq.com',
    REACT_APP_WWW_HOST: 'dev.culinistas.fuzzhq.com',
    REACT_APP_API_HOST: 'culinistas.herokuapp.com/api',
    REACT_APP_SCHEMA: 'https'
  },
  staging: {
    REACT_APP_APP_HOST: 'staging.app.culinistas.fuzzhq.com',
    REACT_APP_WWW_HOST: 'staging.culinistas.fuzzhq.com',
    REACT_APP_API_HOST: 'staging.api.culinistas.fuzzhq.com/api',
    REACT_APP_SCHEMA: 'https'
  },
  production: {
    REACT_APP_APP_HOST: 'app.theculinistas.com',
    REACT_APP_WWW_HOST: 'theculinistas.com',
    REACT_APP_API_HOST: 'api.theculinistas.com/api',
    REACT_APP_SCHEMA: 'https'
  },
  branch: {
    REACT_APP_APP_HOST: process.env.REACT_APP_APP_HOST,
    REACT_APP_WWW_HOST: 'dev.culinistas.fuzzhq.com',
    REACT_APP_API_HOST: 'dev.api.culinistas.fuzzhq.com',
    REACT_APP_SCHEMA: 'http'
  },
  passthru: {
    REACT_APP_APP_HOST: process.env.REACT_APP_APP_HOST,
    REACT_APP_WWW_HOST: process.env.REACT_APP_WWW_HOST,
    REACT_APP_API_HOST: process.env.REACT_APP_API_HOST,
    REACT_APP_SCHEMA: process.env.REACT_APP_SCHEMA
  }
};

// const currentEnv = (process.env.REACT_STATIC_APP_ENV ? process.env.REACT_STATIC_APP_ENV : 'dev');
const currentEnv = process.env.REACT_APP_STATIC_ENV
  ? process.env.REACT_APP_STATIC_ENV
  : 'dev';
export default ENV_CONFIG[currentEnv];



// WEBPACK FOOTER //
// ./src/env.js